import { ifElse, isNil, always } from 'ramda';

export const LOCAL_STORAGE_KEYS = {
  ContentRegistry: 'contentRegistry',
  ContentfulRecentUpdate: 'contentfulRecentUpdate',
  Cookies: 'winnow_cookies_was_accepted',
};

export const persistContentEntities = (data = {}) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.ContentRegistry, JSON.stringify(data));

export const rehydrateContentEntities = async () => {
  const data = await localStorage.getItem(LOCAL_STORAGE_KEYS.ContentRegistry);
  return ifElse(isNil, always({}), x => JSON.parse(x))(data);
};

export const persistContentfulRecentUpdate = (data = {}) =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.ContentfulRecentUpdate, JSON.stringify(data));

export const rehydrateContentfulRecentUpdate = () => localStorage.getItem(LOCAL_STORAGE_KEYS.ContentfulRecentUpdate);

export const setCookiesAccepted = () => localStorage.setItem(LOCAL_STORAGE_KEYS.Cookies, 'true');

export const getHasAcceptedCookies = () => {
  const cookies = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.Cookies));
  return isNil(cookies);
};
